import { useEffect } from 'react'

import { getCookie, setCookie } from '~/utils/cookie.utils'
import appConfig from '~/config/app'

export const IMPACT_REF_COOKIE = 'im_ref'

/**
 * Captures the ?im_ref= query param on first landing and persists it to a
 * 90-day Lax cookie scoped to the apex domain. First-write-wins enforces
 * first-touch attribution (mirrors useReferer pattern).
 *
 * The cookie is scoped to `.houseofmath.com`, so the browser sends it
 * automatically on cross-subdomain requests (frontend → API). The backend
 * reads `req.cookies.im_ref` directly — no explicit header forwarding needed.
 */
export function useImRefCapture(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return
    // No affiliate attribution cookie in the school platform.
    if (appConfig.isSchoolPlatform) return

    const params = new URLSearchParams(window.location.search)
    const incoming = params.get(IMPACT_REF_COOKIE)

    if (!incoming) return

    // First-write-wins: don't overwrite an existing attribution cookie.
    if (getCookie(IMPACT_REF_COOKIE)) return

    // 90 days matches impact.com's typical max click window.
    setCookie({
      name: IMPACT_REF_COOKIE,
      value: incoming,
      expireInDays: 90,
      sameSite: 'Lax',
      domain: '.houseofmath.com',
    })
  }, [])
}
